import { motion } from "framer-motion";

const MENU = [
  {
    course: "Luncheon — Three Days",
    dish: "Roasted Zucchini Quinoa, Chickpeas & Feta",
    detail: "Mediterranean meatballs or day-boat shrimp",
  },
  {
    course: "Dinner I",
    dish: "Creamy Chicken Pesto Rigatoni",
    detail: "Rice pilaf, garden salad",
  },
  {
    course: "Dinner II",
    dish: "Shrimp Fried Rice",
    detail: "Miso green beans",
  },
  {
    course: "Dinner III",
    dish: "Black Bean Enchiladas",
    detail: "Vegetarian, quietly spiced",
  },
  {
    course: "Dessert",
    dish: "Classic Carrot Cake, Cream Cheese Frosting",
    detail: "or dark chocolate cupcakes",
  },
];

export default function Journal() {
  return (
    <section
      data-testid="journal-section"
      className="px-6 sm:px-12 lg:px-20 py-24 md:py-32 lg:py-40 border-b border-white/10"
    >
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1 }}
        className="text-[11px] uppercase tracking-[0.4em] text-[#EAE6DF]/70 mb-6"
      >
        The Journal
      </motion.p>
      <motion.h2
        data-testid="journal-heading"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mb-20 md:mb-28 max-w-2xl"
      >
        Notes from the table.
      </motion.h2>

      <div className="grid grid-cols-12 gap-10 lg:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.4 }}
          className="col-span-12 lg:col-span-5 relative"
        >
          <div className="absolute -bottom-4 -right-4 w-full h-full border border-white/10 pointer-events-none" />
          <img
            data-testid="journal-image"
            src="/images/journal-rigatoni.png"
            alt="Creamy chicken pesto rigatoni on dark stoneware"
            loading="lazy"
            className="relative w-full aspect-[4/5] object-cover"
          />
        </motion.div>

        <div className="col-span-12 lg:col-span-6 lg:col-start-7">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1 }}
            className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-4"
          >
            Nº 01 — Week of August 17, 2026
          </motion.p>
          <motion.h3
            data-testid="journal-entry-title"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif font-light text-2xl sm:text-3xl text-white mb-8"
          >
            A Late-Summer Week, Uptown
          </motion.h3>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="text-sm sm:text-base font-light leading-relaxed text-[#F5F5F7]/60 max-w-xl mb-14"
          >
            Composed for a family of four — luncheons built to hold through long afternoons,
            dinners that wait patiently and arrive warm. Nothing fried twice, nothing wasted;
            the week's rhythm written in basil, grain, and late-August zucchini.
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, delay: 0.15 }}
          >
            {MENU.map((item, i) => (
              <div
                key={item.course}
                data-testid={`journal-menu-item-${i + 1}`}
                className="border-t border-white/10 last:border-b py-6 grid grid-cols-12 gap-4 items-baseline"
              >
                <span className="col-span-12 sm:col-span-4 text-[10px] uppercase tracking-[0.3em] text-[#EAE6DF]/60">
                  {item.course}
                </span>
                <div className="col-span-12 sm:col-span-8">
                  <p className="font-serif font-light text-lg sm:text-xl text-white leading-snug">
                    {item.dish}
                  </p>
                  <p className="mt-1 text-xs font-light tracking-wide text-white/40">
                    {item.detail}
                  </p>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
